import { Select, Seperator, StyledTextArea } from './PasserCommande.styles'
import './MissionsMiseADispo.css'
import { Controller } from 'react-hook-form'
import Flatpickr from 'react-flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import React, { useEffect, useState, useRef } from 'react'
import 'react-phone-input-2/lib/style.css'
import moment from 'moment'
import AutocompleteAddress from '../../Components/GooglePlacesAutoComplete/AutocompleteAddress'
import { CustomInput } from '../RegisterTransporter/style'
import PoidsLours from '../../assets/img/poid_lourd@2x.png'
import VehiculeLeger from '../../assets/img/vehicule_leger@2x.png'
import tonnes7 from '../../assets/img/7.5.png'
import tonnes19 from '../../assets/img/tonnes19.png'
import Fourgon14 from '../../assets/img/fourgon12m.png'
import Fourgon12 from '../../assets/img/captureF12.png'
import Break from '../../assets/img/CaptureBreak.png'
import Semi from '../../assets/img/semi.png'
import SemiImg from '../../assets/img/Capturesemi.png'
import tonnes12 from '../../assets/img/tonnes12.png'
import tracteurSemi from '../../assets/img/tracteur-actos.png'
import vehiculeCamion from '../../assets/img/vehicule_camion.png'
import { useWatch } from 'react-hook-form'
import UploadFileCommande from '../../Components/UploadFileCommande/UploadFileCommande'
import UploadRouteLetterFile from '../../Components/UploadRouteLetterFile/UploadRouteLetterFile'
import { getTemplatesForUser, createTemplate } from '../../api/missionTemplate'
import { computePriceMiseADispoV2, temporisationAtom } from '../../utils/price'
import { useSelector } from 'react-redux'
import { useAtom } from 'jotai'
import { Info, Save } from 'lucide-react'
import { TemplateModal } from '../MissionTemplateManager/TemplateModal'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

function MissionsMiseADispo({
	collapsedItems,
	keepFilesAsObjects,
	i,
	watch,
	register,
	getValues,
	setValue,
	control,
	display,
	distanceVector,
	setDistanceVector,
	priceVector,
	setPriceVector,
	errors,
	setHeur,
	isActiverRippeur,
}) {
	const tarif = useSelector((state) => state.tarif.tarif)
	const token = useSelector((state) => state.auth.token)

	const livraison = useRef()
	livraison.current = watch(`missions[${i}].livraison`, '')
	const manutentionChauffeur = useRef()
	manutentionChauffeur.current = watch(
		`missions[${i}].manutention_chauffeur`,
		''
	)
	const type_transport = useRef()
	type_transport.current = watch(`missions[${i}].type_transport`, '')
	const nature_chargement = useRef()
	nature_chargement.current = watch(`missions[${i}].nature_chargement`, '')
	const assurance = useRef()
	assurance.current = watch(`missions[${i}].assurance`, '')
	const [temporisation, setTemporisation] = useAtom(temporisationAtom)

	const optionsPoidsLourdsValue = useWatch({
		name: `missions[${i}].options_poids_lourds`,
		//defaultValue: [],
		control,
	}) ?? []
	const optionsVehiculeLegerValue = useWatch({
		name: `missions[${i}].options_vehicule_leger`,
		//defaultValue: [],
		control,
	}) ?? [] 
	const type_transport_details_poids_lourds = useWatch({
		name: `missions[${i}].vehicule_poids_lourds`,
		control,
	})
	const type_transport_details = useWatch({
		name: `missions[${i}].type_transport_details`,
		control,
	})


	const [showInfoHeureFin, setShowInfoHeureFin] = useState(false)
	const [showInfoDateFin, setShowInfoDateFin] = useState(false)
	const [typeTransport, setTypeTransport] = useState(null)
	const [optionsPoidsLourds, setOptionsPoidsLourds] = useState([])
	const [optionsVehiculeLeger, setOptionsVehiculeLeger] = useState([])
	const [isBreakDisabled, setIsBreakDisabled] = useState(false)
	const [isF12Disabled, setIsF12Disabled] = useState(false)
	const [isF14Disabled, setIsF14Disabled] = useState(false)
	const [isC20Disabled, setIsC20Disabled] = useState(false)
	const [isV75TDisabled, setIsV75TDisabled] = useState(false)
	const [is12TDisabled, setIs12TDisabled] = useState(false)
	const [is19TDisabled, setIs19TDisabled] = useState(false)
	const [showTooltip, setShowTooltip] = useState(false)
	const [templates, setTemplates] = useState([])
	const [selectedTemplate, setSelectedTemplate] = useState(null)
	const [isTracteurSemiDisabled, setIsTracteurSemiDisabled] = useState(false)
	const [semi, setSemi] = useState(false)
	const nombrePalettes = useRef()
	nombrePalettes.current = watch(`missions[${i}].nombre_palettes`, 0)
	const [isEtageDisabled, setIsEtageDisabled] = useState(false)
	const [showSaveTemplateModal, setShowSaveTemplateModal] = useState(false)
	const [isSavingTemplate, setIsSavingTemplate] = useState(false)
	const [flatpickrKey, setFlatpickrKey] = useState(0)

	const calculateTotalDuration = (
		dateDebut,
		heureDebut,
		dateFin,
		heureFin
	) => {
		if (!dateDebut || !heureDebut || !dateFin || !heureFin) return 0

		const formattedDateDebut = moment(dateDebut).format('DD/MM/YYYY')

		const startDateTime = moment(
			`${formattedDateDebut} ${heureDebut}`,
			'DD/MM/YYYY HH:mm'
		)
		const endDateTime = moment(`${dateFin} ${heureFin}`, 'DD/MM/YYYY HH:mm')

		console.log(
			'Durée totale en minutes :',
			endDateTime.diff(startDateTime, 'minutes')
		)

		return endDateTime.diff(startDateTime, 'minutes')
	}
	console.log('temporisation', temporisation)

	const calculateEndDate = (startDate, startTime, endTime) => {
		const [startHour, startMinute] = startTime?.split(':').map(Number)
		const [endHour, endMinute] = endTime?.split(':').map(Number)
		const startTimeInMinutes = startHour * 60 + startMinute
		const endTimeInMinutes = endHour * 60 + endMinute
		let endDate = moment(startDate, 'DD/MM/YYYY')
		if (endTimeInMinutes <= startTimeInMinutes) {
			endDate = endDate.add(1, 'day')
		}

		return endDate.format('DD/MM/YYYY')
	}

	const filterEndTimeOptions = (startTime = '00:00', startDate) => {
		const [startHour, startMinute] = startTime?.split(':').map(Number)
		const startTimeInMinutes = startHour * 60 + startMinute

		const minEndTimeInMinutes = startTimeInMinutes + 7 * 60 // 7 heures après l'heure de début
		const maxEndTimeInMinutes = startTimeInMinutes + 12 * 60 // 12 heures après l'heure de début

		const options = []
		for (
			let minutes = minEndTimeInMinutes;
			minutes <= maxEndTimeInMinutes;
			minutes += 30
		) {
			const hours = Math.floor(minutes / 60) % 24
			const mins = minutes % 60
			const endTime = `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
			const endDate = calculateEndDate(startDate, startTime, endTime)

			if (startDate) {
				options.push({
					label: `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}         (${endDate})`,
					value: `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`,
				})
			} else {
				options.push({
					label: `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`,
					value: `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`,
				})
			}
		}

		return options
	}
	const generateTimeOptions = (startDate, temporisation) => {
		const options = []
		const currentDate = new Date()
		const currentHour = currentDate.getHours()
		const currentMinute = currentDate.getMinutes()
		const currentDatePlus24Hours = moment()
			.add(24, 'hours')
			.format('DD/MM/YYYY')

		// Vérifier si la date de début est égale à la date actuelle
		if (
			startDate &&
			moment(startDate).format('DD/MM/YYYY') ===
				moment(currentDate).format('DD/MM/YYYY') &&
			temporisation === 'immediat'
		) {
			let startHour = currentHour
			let startMinute = 0
			if (currentMinute > 0 && currentMinute <= 30) {
				startMinute = 30
			} else if (currentMinute > 30) {
				startMinute = 0
				startHour++
			}

			// Boucle pour générer les options de temps à partir de l'heure de début ajustée
			for (let hours = startHour; hours < 24; hours++) {
				for (
					let minutes = hours === startHour ? startMinute : 0;
					minutes < 60;
					minutes += 30
				) {
					const hourText = hours.toString().padStart(2, '0')
					const minuteText = minutes.toString().padStart(2, '0')
					const time = `${hourText}:${minuteText}`
					options.push({ label: time, value: time })
				}
			}
		} else if (
			moment(startDate).format('DD/MM/YYYY') === currentDatePlus24Hours &&
			temporisation === 'planifie'
		) {
			// Extraire uniquement les heures et les minutes
			const timePart = moment().add(24, 'hours').format('HH:mm')
			let [currentHour, currentMinute] = timePart.split(':').map(Number)

			if (currentMinute > 0 && currentMinute <= 30) {
				currentMinute = 30
			} else if (currentMinute > 30) {
				currentMinute = 0
				currentHour++
			}

			// Boucle pour générer les options de temps à partir de l'heure de début ajustée
			for (let hours = currentHour; hours < 24; hours++) {
				for (
					let minutes = hours === currentHour ? currentMinute : 0;
					minutes < 60;
					minutes += 30
				) {
					const hourText = hours.toString().padStart(2, '0')
					const minuteText = minutes.toString().padStart(2, '0')
					const time = `${hourText}:${minuteText}`
					options.push({ label: time, value: time })
				}
			}
		} else {
			// Utiliser la logique d'origine si la date de début n'est pas égale à la date actuelle
			for (let hours = 0; hours < 24; hours++) {
				for (let minutes = 0; minutes < 60; minutes += 30) {
					const hourText = hours.toString().padStart(2, '0')
					const minuteText = minutes.toString().padStart(2, '0')
					const time = `${hourText}:${minuteText}`
					options.push({ label: time, value: time })
				}
			}
		}

		return options
	}
	const handleDateDebutChange = (date_debut) => {
		if (temporisation === 'planifie') {
			const currentDatePlus24Hours = moment()
				.add(24, 'hours')
				.format('DD/MM/YYYY')

			if (
				moment(date_debut, 'DD/MM/YYYY').isBefore(
					moment(currentDatePlus24Hours, 'DD/MM/YYYY')
				)
			) {
				date_debut = moment(
					currentDatePlus24Hours,
					'DD/MM/YYYY'
				).toDate()
			}
		}
		let heure_debut = '00:00'
		const options = generateTimeOptions(date_debut, temporisation)
		if (options.length > 0) {
			heure_debut = options[0].value
			setValue(`missions[${i}].heure_debut`, options[0].value)
		}
		return { date_debut, heure_debut }
	}

	const handleOptionChange = (e) => {
		const selectedOption = e.target.value

		// Si l'option sélectionnée est "Bachée" ou "Frigorifique"
		if (selectedOption === 'Bachée' || selectedOption === 'Frigorifique') {
			// Désélectionner l'autre option si elle est sélectionnée
			const otherOption =
				selectedOption === 'Bachée' ? 'Frigorifique' : 'Bachée'
			const otherOptionCheckbox = document.querySelector(
				`[value="${otherOption}"]`
			)
			if (otherOptionCheckbox) {
				otherOptionCheckbox.checked = false
			}
		}
	}
	function calculerNombreHeures(dateDebut, heureDebut, dateFin, heureFin) {
		const dateTimeDebut = `${moment(dateDebut).format('DD/MM/YYYY')} ${heureDebut}`
		const dateTimeFin = `${dateFin} ${heureFin}`

		const debut = moment(dateTimeDebut, 'DD/MM/YYYY HH:mm')
		const fin = moment(dateTimeFin, 'DD/MM/YYYY HH:mm')

		const totalMinutes = fin.diff(debut, 'minutes')

		// Convertissez les minutes en heures et minutes
		const heures = Math.floor(totalMinutes / 60)
		const minutes = totalMinutes % 60

		// Formatez les résultats en "HH:mm"
		return `${heures}:${minutes < 10 ? '0' : ''}${minutes}`
	}
	const checkWeightCompatibility = (vehicleType, totalWeight) => {
		const weightLimits = {
			Break: 1097,
			'Fourgon 12m³': 1244,
			'Fourgon 14m³': 1353,
			'Camion 20m³': 1200,
			'7,5 Tonnes': 2470,
			'12 Tonnes': 5600,
			'19 Tonnes': 9200,
			Semi: 27000,
			'Tracteur+semi': 1000,
			Tracteur: Infinity,
		}

		const selectedVehicleLimit = weightLimits[vehicleType]
		return totalWeight <= selectedVehicleLimit
	}
	const getCurrentMissionData = () => {
		return watch(`missions[${i}]`)
	}
	// Save mission as template
	const handleSaveAsTemplate = async (templateName) => {
		try {
			setIsSavingTemplate(true)
			const missionData = getCurrentMissionData()

			// Prepare template data
			const templateData = {
				name: templateName,
				fields: {
					adresse_debut: missionData.adresse_debut,
					adresse_fin: missionData.adresse_fin,
					kilometrage: missionData.kilometrage,
					taux_chargement: missionData.taux_chargement,
					notes: missionData.notes,
					manutention_chauffeur:
						missionData.manutention_chauffeur === 'true',
					livraison: missionData.livraison,
					etage: missionData.etage,
					escalier: missionData.escalier,
					ascenseur: missionData.ascenseur,
					poids_total: missionData.poids_total,
					nature_chargement: missionData.nature_chargement,
					nombre_palettes: missionData.nombre_palettes,
					nature_palettes: missionData.nature_palettes,
					nombre_dimension: missionData.nombre_dimension,
					type_transport: missionData.type_transport,
					type_transport_details: missionData.type_transport_details,
					vehicule_poids_lourds: missionData.vehicule_poids_lourds,
					options_vehicule_leger: missionData.options_vehicule_leger,
					options_poids_lourds: missionData.options_poids_lourds,
					danger: missionData.danger === 'true',
					assurance: missionData.assurance === 'true',
					assurance_amount: missionData.assurance_amount,
				},
			}

			await createTemplate(templateData, token)

			// Refresh templates list
			const response = await getTemplatesForUser(token)
			setTemplates(response.templates)

			toast.success('Template sauvegardé avec succès!', {
				style: { fontFamily: 'Montserrat' },
			})
		} catch (error) {
			toast.error('Erreur lors de la sauvegarde du template:', {
				style: { fontFamily: 'Montserrat' },
			})
			console.error('Erreur lors de la sauvegarde du template:', error)
			throw error
		} finally {
			setIsSavingTemplate(false)
		}
	}
	// Fonction pour réinitialiser les champs de la mission
	const resetMissionFields = () => {
		// Réinitialiser tous les champs de base
		setValue(`missions[${i}].adresse_debut`, null)
		setValue(`missions[${i}].adresse_fin`, null)
		setValue(`missions[${i}].kilometrage`, null)
		setValue(`missions[${i}].taux_chargement`, '10')
		setValue(`missions[${i}].notes`, null)
		setValue(`missions[${i}].manutention_chauffeur`, null)
		setValue(`missions[${i}].livraison`, null)
		setValue(`missions[${i}].etage`, null)
		setValue(`missions[${i}].escalier`, false)
		setValue(`missions[${i}].ascenseur`, false)
		setValue(`missions[${i}].poids_total`, null)
		setValue(`missions[${i}].nature_chargement`, null)
		setValue(`missions[${i}].nombre_palettes`, null)
		setValue(`missions[${i}].nature_palettes`, null)
		setValue(`missions[${i}].nombre_dimension`, null)
		setValue(`missions[${i}].type_transport`, null)
		setValue(`missions[${i}].type_transport_details`, null)
		setValue(`missions[${i}].vehicule_poids_lourds`, null)
		setValue(`missions[${i}].options_vehicule_leger`, [])
		setValue(`missions[${i}].options_poids_lourds`, [])
		setValue(`missions[${i}].danger`, null)
		setValue(`missions[${i}].assurance`, null)
		setValue(`missions[${i}].assurance_amount`, null)
		setValue(`missions[${i}].templateId`, null)
		setValue(`missions[${i}].prix`, 0)
		// Réinitialiser les états locaux
		setTypeTransport(null)
		setOptionsPoidsLourds([])
		setOptionsVehiculeLeger([])
		setSelectedTemplate(null)
	}

	// Fonction stricte pour vérifier si toutes les informations essentielles sont complètes
	const canSaveAsTemplate = () => {
		const missionData = watch(`missions[${i}]`)

		// Ne pas permettre la sauvegarde si un template est déjà sélectionné
		if (watch(`missions[${i}].templateId`)) {
			return false
		}

		// Vérifications des champs obligatoires pour un template complet
		const hasAddresses =
			missionData?.adresse_debut && missionData?.adresse_fin
		const hasTransportType = missionData?.type_transport
		const hasTransportDetails =
			missionData?.type_transport === 'Véhicule léger'
				? missionData?.type_transport_details
				: missionData?.vehicule_poids_lourds
		const hasTransportOptions =
			missionData?.type_transport === 'Véhicule léger'
				? missionData?.options_vehicule_leger &&
					missionData?.options_vehicule_leger.length > 0
				: missionData?.options_poids_lourds &&
					missionData?.options_poids_lourds.length > 0
		const hasWeight =
			missionData?.poids_total && Number(missionData.poids_total) > 0
		const hasCargoNature = missionData?.nature_chargement
		const hasCargoDetails =
			missionData?.nature_chargement === 'palette'
				? missionData?.nombre_palettes && missionData?.nature_palettes
				: missionData?.nombre_dimension
		const hasManutention =
			missionData?.manutention_chauffeur !== undefined &&
			missionData?.manutention_chauffeur !== null &&
			missionData?.manutention_chauffeur !== ''
		const hasLivraison = missionData?.livraison
		const hasDanger =
			missionData?.danger !== undefined &&
			missionData?.danger !== null &&
			missionData?.danger !== ''
		const hasAssurance =
			missionData?.assurance !== undefined &&
			missionData?.assurance !== null &&
			missionData?.assurance !== ''

		// Vérification spéciale pour l'assurance
		const hasAssuranceAmount =
			missionData?.assurance === 'true'
				? missionData?.assurance_amount &&
					missionData?.assurance_amount.trim() !== ''
				: true // Si assurance = false, pas besoin du montant

		// Tous les champs essentiels doivent être remplis
		return (
			hasAddresses &&
			hasTransportType &&
			hasTransportDetails &&
			hasTransportOptions &&
			hasWeight &&
			hasCargoNature &&
			hasCargoDetails &&
			hasManutention &&
			hasLivraison &&
			hasDanger &&
			hasAssurance &&
			hasAssuranceAmount
		)
	}

	// Fonction pour obtenir les champs manquants (pour affichage à l'utilisateur)
	const getMissingFields = () => {
		const missionData = watch(`missions[${i}]`)
		const missing = []

		if (!missionData?.adresse_debut) missing.push(t("start_address"))
		if (!missionData?.adresse_fin) missing.push(t("end_address"))
		if (!missionData?.type_transport) missing.push(t("transport_type"))
		if (
			missionData?.type_transport === 'Véhicule léger' &&
			!missionData?.type_transport_details
		)
			missing.push(t("light_vehicle_details"))
		if (
			missionData?.type_transport === 'Poids lourds' &&
			!missionData?.vehicule_poids_lourds
		)
			missing.push(t("heavy_truck_details"))
		if (
			missionData?.type_transport === 'Véhicule léger' &&
			(!missionData?.options_vehicule_leger ||
				missionData?.options_vehicule_leger.length === 0)
		)
			missing.push(t("light_vehicle_options"))
		if (
			missionData?.type_transport === 'Poids lourds' &&
			(!missionData?.options_poids_lourds ||
				missionData?.options_poids_lourds.length === 0)
		)
			missing.push(t("heavy_truck_options"))
		if (!missionData?.poids_total || Number(missionData.poids_total) <= 0)
			missing.push(t("total_weight"))
		if (!missionData?.nature_chargement)
			missing.push(t("load_type"))
		if (
			missionData?.nature_chargement === 'palette' &&
			(!missionData?.nombre_palettes || !missionData?.nature_palettes)
		)
			missing.push(t("pallet_details"))
		if (
			missionData?.nature_chargement === 'vrac' &&
			!missionData?.nombre_dimension
		)
			missing.push(t("vehicle_detail1"))
		if (
			missionData?.manutention_chauffeur === undefined ||
			missionData?.manutention_chauffeur === null ||
			missionData?.manutention_chauffeur === ''
		)
			missing.push(t("driver_handling"))
		if (!missionData?.livraison) missing.push(t("delivery_location"))
		if (
			missionData?.danger === undefined ||
			missionData?.danger === null ||
			missionData?.danger === ''
		)
			missing.push(t("transport_of_hazardous_materials"))
		if (
			missionData?.assurance === undefined ||
			missionData?.assurance === null ||
			missionData?.assurance === ''
		)
			missing.push(t("insurance"))
		if (
			missionData?.assurance === 'true' &&
			(!missionData?.assurance_amount ||
				missionData?.assurance_amount.trim() === '')
		)
			missing.push(t("insurance_amount"))

		return missing
	}

	useEffect(() => {
		const totalWeight = Number(watch(`missions[${i}].poids_total`)) || 0
		const currentVehicle =
			watch(`missions[${i}].type_transport_details`) ||
			watch(`missions[${i}].vehicule_poids_lourds`)

		if (currentVehicle && totalWeight > 0) {
			const isCompatible = checkWeightCompatibility(
				currentVehicle,
				totalWeight
			)

			if (!isCompatible) {
				setValue(`missions[${i}].type_transport_details`, undefined)
				setValue(`missions[${i}].vehicule_poids_lourds`, undefined)
				setTypeTransport(null)
			}
		}
	}, [
		watch(`missions[${i}].poids_total`),
		watch(`missions[${i}].type_transport_details`),
		watch(`missions[${i}].vehicule_poids_lourds`),
	])

	useEffect(() => {
		const currentLivraison = watch(`missions[${i}].livraison`)
		if (
			currentLivraison &&
			currentLivraison !== 'Domicile/Batiment/Maison'
		) {
			setValue(`missions[${i}].etage`, 'RDC')

			setValue(`missions[${i}].escalier`, false)
			setValue(`missions[${i}].ascenseur`, false)
		}
	}, [watch(`missions[${i}].livraison`)])

	// Add this at the top of your useEffect section
	useEffect(() => {
		// Initialize typeTransport based on existing values when component re-mounts
		console.log('this')
		if (
			watch(`missions[${i}].type_transport`) === 'Véhicule léger' &&
			watch(`missions[${i}].type_transport_details`)
		) {
			setTypeTransport(watch(`missions[${i}].type_transport_details`))
		} else if (
			watch(`missions[${i}].type_transport`) === 'Poids lourds' &&
			watch(`missions[${i}].vehicule_poids_lourds`)
		) {
			setTypeTransport(watch(`missions[${i}].vehicule_poids_lourds`))
		}
	}, []) // Empty dependency array ensures it only runs once on mount
	useEffect(() => {
		if (
			watch(`missions[${i}].date_debut`) &&
			watch(`missions[${i}].date_fin`) &&
			watch(`missions[${i}].heure_debut`) &&
			watch(`missions[${i}].heure_fin`)
		) {
			const resulta = calculerNombreHeures(
				watch(`missions[${i}].date_debut`),
				watch(`missions[${i}].heure_debut`),
				watch(`missions[${i}].date_fin`),
				watch(`missions[${i}].heure_fin`)
			)
			console.log('resulta', resulta)
			setValue(`missions[${i}].heure_rippeur`, resulta)
		}
	}, [
		watch(`missions[${i}].date_debut`),
		watch(`missions[${i}].date_fin`),
		watch(`missions[${i}].heure_fin`),
		watch(`missions[${i}].heure_debut`),
	])
	useEffect(() => {
		const isNonChauffeurHandling = watch(
			`missions[${i}].manutention_chauffeur`
		)
		const nombreRippeur = watch(`missions[${i}].nombre_rippeur`)

		if (isActiverRippeur) {
			setIsEtageDisabled(
				isNonChauffeurHandling === 'false' && nombreRippeur <= 0
			)
			if (isNonChauffeurHandling === 'false' && nombreRippeur <= 0) {
				setValue(`missions[${i}].etage`, 'RDC')
				setValue(`missions[${i}].escalier`, '')
				setValue(`missions[${i}].ascenseur`, '')
			}
		} else {
			setIsEtageDisabled(isNonChauffeurHandling === 'false')
			if (isNonChauffeurHandling === 'false') {
				setValue(`missions[${i}].etage`, 'RDC')
				setValue(`missions[${i}].escalier`, false)
				setValue(`missions[${i}].ascenseur`, false)
			}
		}

		if (isNonChauffeurHandling === 'true' || nombreRippeur > 0) {
			setIsEtageDisabled(false)
		}

		// Disable escalier and ascenseur when RDC is selected
		const currentEtage = watch(`missions[${i}].etage`)
		if (currentEtage === 'RDC') {
			setValue(`missions[${i}].escalier`, false)
			setValue(`missions[${i}].ascenseur`, false)
		}
	}, [
		watch(`missions[${i}].manutention_chauffeur`),
		watch(`missions[${i}].nombre_rippeur`),
		watch(`missions[${i}].etage`),
	])

	// Type de transport switching
	useEffect(() => {
		if (watch(`missions[${i}].type_transport_details`)) {
			setTypeTransport(watch(`missions[${i}].type_transport_details`))
		}
	}, [watch(`missions[${i}].type_transport_details`)])

	useEffect(() => {
		if (watch(`missions[${i}].vehicule_poids_lourds`)) {
			setTypeTransport(watch(`missions[${i}].vehicule_poids_lourds`))
		}
	}, [watch(`missions[${i}].vehicule_poids_lourds`)])

	useEffect(() => {
		if (type_transport.current === 'Véhicule léger') {
			setValue(`missions[${i}].vehicule_poids_lourds`, [], {
				shouldValidate: true,
			})
			setValue(`missions[${i}].options_poids_lourds`, [], {
				shouldValidate: true,
			})
			setTypeTransport(type_transport_details)
		}
		if (type_transport.current === 'Poids lourds') {
			setValue(`missions[${i}].type_transport_details`, [], {
				shouldValidate: true,
			})
			setValue(`missions[${i}].options_vehicule_leger`, [], {
				shouldValidate: true,
			})
			setTypeTransport(type_transport_details_poids_lourds)
		}
	}, [type_transport.current])

	useEffect(() => {
		const fetchTemplates = async () => {
			try {
				const response = await getTemplatesForUser(token)
				setTemplates(response.templates)
				// Restaurer le template sélectionné s'il existe
				const savedTemplateId = watch(`missions[${i}].templateId`)
				if (savedTemplateId) {
					const savedTemplate = response.templates.find(
						(t) => t._id === savedTemplateId
					)
					if (savedTemplate) {
						setSelectedTemplate(savedTemplate)
						applyTemplate(savedTemplate)
					}
				}
			} catch (error) {
				console.error('Erreur lors du chargement des templates', error)
			}
		}

		fetchTemplates()
	}, [token])

	const applyTemplate = (template) => {
		if (!template) return
		setValue(`missions[${i}].templateId`, template._id)

		// Remplir les champs principaux
		setValue(`missions[${i}].adresse_debut`, template.adresse_debut)
		setValue(`missions[${i}].adresse_fin`, template.adresse_fin)
		setValue(`missions[${i}].kilometrage`, template.kilometrage)
		setValue(`missions[${i}].taux_chargement`, template.taux_chargement)
		setValue(`missions[${i}].notes`, template.notes)
		setValue(
			`missions[${i}].manutention_chauffeur`,
			template.manutention_chauffeur ? 'true' : 'false'
		)
		setValue(`missions[${i}].livraison`, template.livraison)
		setValue(`missions[${i}].etage`, template.etage)
		setValue(`missions[${i}].escalier`, template.escalier)
		setValue(`missions[${i}].ascenseur`, template.ascenseur)
		setValue(`missions[${i}].poids_total`, template.poids_total)
		setValue(`missions[${i}].nature_chargement`, template.nature_chargement)

		// Remplir les champs conditionnels
		if (template.nature_chargement === 'palette') {
			setValue(`missions[${i}].nombre_palettes`, template.nombre_palettes)
			setValue(`missions[${i}].nature_palettes`, template.nature_palettes)
		} else {
			setValue(
				`missions[${i}].nombre_dimension`,
				template.nombre_dimension
			)
		}

		// Remplir les champs de transport
		setValue(`missions[${i}].type_transport`, template.type_transport)

		if (template.type_transport === 'Véhicule léger') {
			console.log(
				' template.options_vehicule_leger',
				template.options_vehicule_leger
			)
			setValue(
				`missions[${i}].type_transport_details`,
				template.type_transport_details
			)
			setValue(
				`missions[${i}].options_vehicule_leger`,
				template.options_vehicule_leger
			)
		} else {
			setValue(
				`missions[${i}].vehicule_poids_lourds`,
				template.vehicule_poids_lourds
			)
			setValue(
				`missions[${i}].options_poids_lourds`,
				template.options_poids_lourds
			)
		}

		// Remplir les options supplémentaires
		setValue(`missions[${i}].danger`, template.danger ? 'true' : 'false')
		setValue(
			`missions[${i}].assurance`,
			template.assurance ? 'true' : 'false'
		)
		setValue(`missions[${i}].assurance_amount`, template.assurance_amount)

		setSelectedTemplate(template)
	}

	// Options switching
	useEffect(() => {
		if (watch(`missions[${i}].options_poids_lourds`)) {
			setOptionsPoidsLourds(watch(`missions[${i}].options_poids_lourds`))
		}
	}, [watch(`missions[${i}].options_poids_lourds`)])
	useEffect(() => {
		if (watch(`missions[${i}].options_vehicule_leger`)) {
			setOptionsVehiculeLeger(
				watch(`missions[${i}].options_vehicule_leger`)
			)
		}
	}, [watch(`missions[${i}].options_vehicule_leger`)])

	useEffect(() => {
		const natureChargement = watch(`missions[${i}].nature_chargement`)
		const nombrePalettes =
			Number(watch(`missions[${i}].nombre_palettes`)) || 0
		const nombreDimension =
			Number(watch(`missions[${i}].nombre_dimension`)) || 0
		const poidsTotal = Number(watch(`missions[${i}].poids_total`)) || 0

		// Transport mapping configurations, maybe I will be moving it to some sort of constant file later
		const getTransportMappings = (nature) => {
			const mappings = {
				palette: [
					{
						threshold: 2,
						detail: 'Break',
						field: 'type_transport_details',
					},
					{
						threshold: 5,
						detail: 'Fourgon 12m³',
						field: 'type_transport_details',
					},
					{
						threshold: 6,
						detail: 'Fourgon 14m³',
						field: 'type_transport_details',
					},
					{
						threshold: 7,
						detail: 'Camion 20m³',
						field: 'type_transport_details',
					},
					{
						threshold: 16,
						detail: '7,5 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 19,
						detail: '12 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 22,
						detail: '19 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 33,
						detail: 'Semi',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 33,
						detail: 'Tracteur+semi',
						field: 'vehicule_poids_lourds',
					},
				],
				vrac: [
					{
						threshold: 6,
						detail: 'Break',
						field: 'type_transport_details',
					},
					{
						threshold: 12,
						detail: 'Fourgon 12m³',
						field: 'type_transport_details',
					},
					{
						threshold: 14,
						detail: 'Fourgon 14m³',
						field: 'type_transport_details',
					},
					{
						threshold: 20,
						detail: 'Camion 20m³',
						field: 'type_transport_details',
					},
					{
						threshold: 30,
						detail: '7,5 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 45,
						detail: '12 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 58,
						detail: '19 Tonnes',
						field: 'vehicule_poids_lourds',
					},
					{
						threshold: 86,
						detail: 'Semi',
						field: 'vehicule_poids_lourds',
					},
				],
			}
			return mappings[nature] || []
		}

		const WEIGHT_LIMITS = {
			Break: 1097,
			'Fourgon 12m³': 1244,
			'Fourgon 14m³': 1353,
			'Camion 20m³': 1200,
			'7,5 Tonnes': 2470,
			'12 Tonnes': 5600,
			'19 Tonnes': 9200,
			Semi: 27000,
			'Tracteur+semi': 27000,
		}

		// Function to check if transport should be disabled, this jumps between weights and nature_chargement
		const isTransportDisabled = (transportDetail) => {
			const mappings = getTransportMappings(natureChargement)
			const currentQuantity =
				natureChargement === 'palette'
					? nombrePalettes
					: nombreDimension

			const weightExceeded = poidsTotal > WEIGHT_LIMITS[transportDetail]

			let quantityExceeded = false
			if (natureChargement && mappings.length > 0) {
				const mapping = mappings.find(
					(m) => m.detail === transportDetail
				)
				quantityExceeded = mapping
					? currentQuantity > mapping.threshold
					: false
			}

			return weightExceeded || quantityExceeded
		}

		const updateTransportAvailability = () => {
			setIsBreakDisabled(isTransportDisabled('Break'))
			setIsF12Disabled(isTransportDisabled('Fourgon 12m³'))
			setIsF14Disabled(isTransportDisabled('Fourgon 14m³'))
			setIsC20Disabled(isTransportDisabled('Camion 20m³'))
			setIsV75TDisabled(isTransportDisabled('7,5 Tonnes'))
			setIs12TDisabled(isTransportDisabled('12 Tonnes'))
			setIs19TDisabled(isTransportDisabled('19 Tonnes'))
			setSemi(isTransportDisabled('Semi'))
			setIsTracteurSemiDisabled(isTransportDisabled('Tracteur+semi'))
		}

		const clearInvalidTransportSelections = () => {
			if (!natureChargement) return // Don't clear selections if nature not chosen yet

			const mappings = getTransportMappings(natureChargement)
			const currentQuantity =
				natureChargement === 'palette'
					? nombrePalettes
					: nombreDimension

			mappings.forEach((mapping) => {
				const currentSelection = watch(
					`missions[${i}].${mapping.field}`
				)

				const shouldBeDisabled = isTransportDisabled(mapping.detail)

				if (shouldBeDisabled && currentSelection === mapping.detail) {
					setTypeTransport(null)
					setValue(`missions[${i}].${mapping.field}`, undefined)
				}
			})
		}

		const handleNatureBasedFieldClearing = () => {
			if (natureChargement === 'palette') {
				setValue(`missions[${i}].nombre_dimension`, null)
			} else if (natureChargement === 'vrac') {
				setValue(`missions[${i}].nombre_palettes`, null)
				setValue(`missions[${i}].nature_palettes`, null)
			}
		}

		// 1. Always update transport availability (weight + conditional quantity constraints)
		updateTransportAvailability()

		// 2. Handle nature-specific field clearing
		handleNatureBasedFieldClearing()

		// 3. Clear invalid selections (only if nature is selected)
		clearInvalidTransportSelections()
	}, [
		watch(`missions[${i}].nature_chargement`),
		watch(`missions[${i}].nombre_dimension`),
		watch(`missions[${i}].nombre_palettes`),
		watch(`missions[${i}].poids_total`),
		watch(`missions[${i}].type_transport_details`),
		watch(`missions[${i}].vehicule_poids_lourds`),
		i,
	])

	useEffect(() => {
		setDistanceVector(
			new Map(
				distanceVector.set(
					`${i}`,
					watch(`missions[${i}].kilometrage`) * 1000
				)
			)
		)
	}, [watch(`missions[${i}].kilometrage`)])

	useEffect(() => {
		setFlatpickrKey((prev) => prev + 1)
	}, [temporisation])
	useEffect(() => {
		setPriceVector(
			new Map(priceVector.set(`${i}`, watch(`missions[${i}].prix`)))
		)
	}, [watch(`missions[${i}].prix`)])

	useEffect(() => {
		if (
			watch(`missions[${i}].heure_debut`) &&
			watch(`missions[${i}].heure_fin`) &&
			watch(`missions[${i}].kilometrage`) &&
			(optionsVehiculeLeger || optionsPoidsLourds)
		) {
			const startDate = watch(`missions[${i}].date_debut`)
			const startTime = watch(`missions[${i}].heure_debut`)
			const endDate = watch(`missions[${i}].date_fin`)
			const endTime = watch(`missions[${i}].heure_fin`)
			const danger = watch(`missions[${i}].danger`)

			// Convertir startDate en format 'YYYY-MM-DD'
			const startDateFormatted = moment(startDate).format('YYYY-MM-DD')
			// Déterminer le format de endDate
			const endDateFormat = endDate.includes('/')
				? 'DD/MM/YYYY'
				: 'YYYY-MM-DD'

			// Combinez les dates et les heures
			const startDateTime = `${startDateFormatted} ${startTime}`
			const endDateTime = `${endDate} ${endTime}`

			// Créez des objets moment
			const startMoment = moment(startDateTime, 'YYYY-MM-DD HH:mm')
			const endMoment = moment(endDateTime, `${endDateFormat} HH:mm`)

			// Calculez la différence en heures
			const heures = endMoment.diff(startMoment, 'hours', true)
			const kilo_jour = watch(`missions[${i}].kilometrage`)
			const heureRippeur = watch(`missions[${i}].heure_rippeur`)
			const nbrRippeur = watch(`missions[${i}].nombre_rippeur`)

			let updatedMission = { heures, kilo_jour, heureRippeur, nbrRippeur }

			if (
				watch(`missions[${i}].livraison`) === 'Domicile/Batiment/Maison'
			) {
				const nombreEtage = watch(`missions[${i}].etage`)
				const typeEtage = watch(`missions[${i}.type_etage]`)
				updatedMission = { ...updatedMission, nombreEtage, typeEtage }
			}

			if (
				watch(`missions[${i}].type_transport`) === 'Véhicule léger' &&
				watch(`missions[${i}].type_transport_details`)
			) {
				setTypeTransport(watch(`missions[${i}].type_transport_details`))
			} else if (
				watch(`missions[${i}].type_transport`) === 'Poids lourds' &&
				watch(`missions[${i}].vehicule_poids_lourds`)
			) {
				setTypeTransport(watch(`missions[${i}].vehicule_poids_lourds`))
			}

			updatedMission = { ...updatedMission, typeTransport: typeTransport }

			if (optionsVehiculeLeger) {
				updatedMission = {
					...updatedMission,
					optionsVehiculeLeger: optionsVehiculeLeger,
				}
			}
			if (optionsPoidsLourds) {
				updatedMission = {
					...updatedMission,
					optionsPoidsLourds: optionsPoidsLourds,
				}
			}
			if (danger) {
				updatedMission = { ...updatedMission, danger: danger }
			}
			if (!watch('type_commande')) return
			if (!kilo_jour) return
			if (!heures) return
			console.log('updated mission', updatedMission)
			const prix = computePriceMiseADispoV2(tarif, updatedMission)

			setValue(`missions[${i}].prix`, prix)
		}
	}, [
		watch(`missions[${i}].heure_debut`),
		watch(`missions[${i}].heure_fin`),
		watch(`missions[${i}].kilometrage`),
		watch(`missions[${i}].heure_rippeur`),
		watch(`missions[${i}].nombre_rippeur`),
		watch(`missions[${i}].livraison`),
		watch(`missions[${i}].etage`),
		watch(`missions[${i}].type_etage`),
		watch(`missions[${i}].vehicule_poids_lourds`),
		watch(`missions[${i}].type_transport_details`),
		typeTransport,
		optionsVehiculeLeger,
		optionsPoidsLourds,
		watch(`missions[${i}].danger`),
	])
    const {t} = useTranslation()
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

    useEffect(() => {
        const checkScreen = () => {
            const width = window.innerWidth;

            setIsMobile(width < 768);

        };
        checkScreen();
        window.addEventListener('resize', checkScreen);

        return () => window.removeEventListener('resize', checkScreen);
    }, []);
	return (
		<div>
			<input type='hidden' {...register(`missions[${i}].templateId`)} />
			<div style={{ marginBottom: '2rem' }}>
				<label
					style={{
						display: 'block',
						marginBottom: '0.5rem',
						fontWeight: 'bold',
					}}
				>
					{t("use_template")}
				</label>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
					}}
				>
					<select
						value={watch(`missions[${i}].templateId`) || ''}
						onChange={(e) => {
							const templateId = e.target.value
							if (templateId === '') {
								resetMissionFields()
							} else {
								const template = templates.find(
									(t) => t._id === templateId
								)
								applyTemplate(template)
							}
						}}
						style={{
							width: '100%',
							padding: '0.75rem',
							borderRadius: '0.5rem',
							border: '1px solid #e2e8f0',
							backgroundColor: '#f8fafc',
							fontSize: '1rem',
							flex: 1,
						}}
					>
						<option value=''>{t("select_template")}</option>
						{templates.map((template) => (
							<option key={template._id} value={template._id}>
								{template.name}
							</option>
						))}
					</select>

					{watch(`missions[${i}].templateId`) && (
						<button
							type='button'
							onClick={() => {
								resetMissionFields()
								setValue(`missions[${i}].templateId`, null)
							}}
							style={{
								padding: '0.5rem 1rem',
								backgroundColor: '#ef4444',
								color: 'white',
								border: 'none',
								borderRadius: '0.375rem',
								cursor: 'pointer',
								display: 'flex',
								alignItems: 'center',
								gap: '0.25rem',
								whiteSpace: 'nowrap',
							}}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='16'
								height='16'
								viewBox='0 0 24 24'
								fill='none'
								stroke='currentColor'
								strokeWidth='2'
								strokeLinecap='round'
								strokeLinejoin='round'
							>
								<line x1='18' y1='6' x2='6' y2='18'></line>
								<line x1='6' y1='6' x2='18' y2='18'></line>
							</svg>
							{t("deselect")}
						</button>
					)}
				</div>

				{watch(`missions[${i}].templateId`) && (
					<div
						style={{
							marginTop: '0.5rem',
							color: 'green',
							display: 'flex',
							alignItems: 'center',
							gap: '0.25rem',
						}}
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='16'
							height='16'
							viewBox='0 0 24 24'
							fill='none'
							stroke='currentColor'
							strokeWidth='2'
							strokeLinecap='round'
							strokeLinejoin='round'
						>
							<polyline points='20 6 9 17 4 12'></polyline>
						</svg>
						{t("template_applied")}
					</div>
				)}
			</div>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
					}}
				>
					<span
						style={{
							marginBottom: '1rem',
							color: 'black',
							fontSize: 14,
						}}
					>
						{t("start_address")} <span style={{ color: 'red' }}>*</span>
					</span>

					<Controller
						name={`missions[${i}].adresse_debut`}
						rules={{ required: true }}
						control={control}
						render={({ field: { onChange, value } }) => (
							<AutocompleteAddress
								onPlaceSelect={(placeDetails) => {
									console.log(
										'Place ID:',
										placeDetails.place_id
									)
									console.log(
										'Description:',
										placeDetails.description
									)
								}}
								onValueChange={async (selectedValue) => {
									if (selectedValue) {
										onChange(selectedValue)
									}
								}}
								value={value}
							/>
						)}
					/>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].adresse_debut && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("location_err" )}
							</div>
						)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							{t("end_address")}{' '}
							<span style={{ color: 'red' }}>*</span>
						</span>
					</div>

					<Controller
						name={`missions[${i}].adresse_fin`}
						rules={{ required: true }}
						control={control}
						render={({ field: { onChange, value } }) => (
							<AutocompleteAddress
								value={value}
								onPlaceSelect={(placeDetails) => {
									console.log(
										'Place ID:',
										placeDetails.place_id
									)
									console.log(
										'Description:',
										placeDetails.description
									)
								}}
								onValueChange={async (selectedValue) => {
									if (selectedValue) {
										onChange(selectedValue)
									}
								}}
							/>
						)}
					/>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].adresse_fin && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("location_end_err")}
							</div>
						)}
				</div>
			</div>
			<div
				style={{
					display: collapsedItems.includes(i) ? 'none' : 'flex',
					flexDirection: 'column',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							position: 'relative',
						}}
					>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							{t("start_date")}{' '}
							<span style={{ color: 'red' }}>*</span>
						</span>
					</div>
					<Controller
						name={`missions[${i}].date_debut`}
						rules={{ required: true }}
						control={control}
						render={({ field: { onChange, value } }) => (
							<Flatpickr
								key={flatpickrKey}
								options={{
									mode: 'single',
									locale: French,
									...(temporisation === 'immediat' &&
										(() => {
											const currentTime = moment()
											const cutoffTime = moment().set({
												hour: 21,
												minute: 30,
											})

											const minDate = currentTime.isAfter(
												cutoffTime
											)
												? moment()
														.add(1, 'day')
														.startOf('day')
														.toDate()
												: moment()
														.startOf('day')
														.toDate()

											const maxDate = moment()
												.add(24, 'hours')
												.toDate()

											return {
												minDate,
												maxDate,
												disable: [
													(date) => date > maxDate,
												],
											}
										})()),

									...(temporisation === 'planifie' && {
										minDate: moment()
											.add(1, 'day')
											.startOf('day')
											.toDate(),
									}),

									dateFormat: 'd/m/Y',
								}}
								onChange={([date]) => {
									const resulta = handleDateDebutChange(date)
									onChange(resulta.date_debut)

									const endTimeOptions = filterEndTimeOptions(
										resulta.heure_debut,
										resulta.date_debut
									)
									if (endTimeOptions.length > 0) {
										const firstEndTime =
											endTimeOptions[0].value
										const newEndDate = calculateEndDate(
											resulta.date_debut,
											resulta.heure_debut,
											firstEndTime
										)
										setValue(
											`missions[${i}].date_fin`,
											newEndDate
										)
										setValue(
											`missions[${i}].heure_fin`,
											firstEndTime
										)
									}
								}}
								className='date-input'
								value={value}
							/>
						)}
					/>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].date_debut && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("transport_date_err")}
							</div>
						)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: isMobile? 'column' :'row',
						marginBottom: '2.5rem',
						gap : isMobile? '1rem' : 0
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: isMobile? '100%' : '50%',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								position: 'relative',
							}}
						>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
								}}
							>
								{t("start_time")}{' '}
								<span style={{ color: 'red' }}>*</span>
							</span>
						</div>
						<Controller
							name={`missions[${i}].heure_debut`}
							rules={{ required: true }}
							control={control}
							render={({ field: { onChange, value } }) => (
								<select
									value={value || ''}
									disabled={display}
									onChange={(e) => {
										onChange(e.target.value)
										const endTimeOptions =
											filterEndTimeOptions(
												e.target.value,
												watch(
													`missions[${i}].date_debut`
												)
											)
										if (endTimeOptions.length > 0) {
											const firstEndTime =
												endTimeOptions[0].value
											const newEndDate = calculateEndDate(
												watch(
													`missions[${i}].date_debut`
												),
												e.target.value,
												firstEndTime
											)
											setValue(
												`missions[${i}].heure_fin`,
												firstEndTime
											)
											setValue(
												`missions[${i}].date_fin`,
												newEndDate
											)
										}
									}}
									style={{
										padding: '1rem',
										borderRadius: '0.5rem',
										color: '#858ea8',
										border: 'none',
										fontFamily: 'Montserrat',
										flex: '1',
										outline: 'none',
									}}
								>
									{generateTimeOptions(
										watch(`missions[${i}].date_debut`),
										temporisation
									).map((option) => (
										<option
											key={option.value}
											value={option.value}
										>
											{option.label}
										</option>
									))}
								</select>
							)}
						/>
						{errors &&
							errors.missions &&
							errors.missions[i] &&
							errors.missions[i].heure_debut && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("time_err")}
								</div>
							)}
					</div>
					<div
						style={{
							width: '1rem',
						}}
					/>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: isMobile? '100%' : '50%',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								position: 'relative',
							}}
						>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
								}}
							>
								{t("end_time")}{' '}
								<span style={{ color: 'red' }}>*</span>
							</span>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								style={{
									width: 20,
									height: 20,
									marginLeft: 10,
								}}
								fill='none'
								viewBox='0 0 24 24'
								stroke='#858ea8'
								onClick={() => {
									setShowInfoHeureFin(true)
								}}
								onMouseLeave={() => {
									setShowInfoHeureFin(false)
								}}
							>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth={2}
									d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
								/>
							</svg>
							{showInfoHeureFin && (
								<div
									style={{
										position: 'absolute',
										top: '20px',
										left: '150px',
										padding: '0.5rem',
										border: '1px solid #ccc',
										borderRadius: '0.5rem',
										background: '#FFFFFF',
										boxShadow:
											'0px 2px 5px rgba(0, 0, 0, 0.1)',
										zIndex: 1000,
										width: 'calc(100% - 30px)',
									}}
								>
									<p
										style={{
											color: '#333',
											fontSize: '14px',
											marginBottom: '0.5rem',
										}}
									>
										{t("end_time_err")}.
									</p>
								</div>
							)}
						</div>
						<Controller
							name={`missions[${i}].heure_fin`}
							rules={{ required: true }}
							control={control}
							render={({ field: { onChange, value } }) => (
								<select
									value={value || ''}
									disabled={display}
									onChange={(e) => {
										onChange(e.target.value)
										const newEndDate = calculateEndDate(
											watch(`missions[${i}].date_debut`),
											watch(`missions[${i}].heure_debut`),
											e.target.value
										)
										setValue(
											`missions[${i}].date_fin`,
											newEndDate
										)
									}}
									style={{
										padding: '1rem',
										borderRadius: '0.5rem',
										color: '#858ea8',
										border: 'none',
										fontFamily: 'Montserrat',
										flex: '1',
										outline: 'none',
									}}
								>
									{filterEndTimeOptions(
										watch(`missions[${i}].heure_debut`),
										watch(`missions[${i}].date_debut`)
									).map((option) => (
										<option
											key={option.value}
											value={option.value}
										>
											{option.label}
										</option>
									))}
								</select>
							)}
						/>
						{errors &&
							errors.missions &&
							errors.missions[i] &&
							errors.missions[i].heure_fin && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{t("transport_end_time_err")}
								</div>
							)}
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							position: 'relative',
						}}
					>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							{t("end_date")} <span style={{ color: 'red' }}>*</span>
						</span>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							style={{
								width: 20,
								height: 20,

								marginLeft: 10,
							}}
							fill='none'
							viewBox='0 0 24 24'
							stroke='#858ea8'
							onClick={() => {
								setShowInfoDateFin(true)
							}}
							onMouseLeave={() => {
								setShowInfoDateFin(false)
							}}
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth={2}
								d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
							/>
						</svg>
						{showInfoDateFin && (
							<div
								style={{
									position: 'absolute',
									top: '20px',
									left: '150px',
									padding: '0.5rem',
									border: '1px solid #ccc',
									borderRadius: '0.5rem',
									background: '#FFFFFF',
									boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
									zIndex: 1000,
									width: 'calc(100% - 30px)',
								}}
							>
								<p
									style={{
										color: '#333',
										fontSize: '14px',
										marginBottom: '0.5rem',
									}}
								>
									{t("end_date_err1")}
								</p>
							</div>
						)}
					</div>
					<Controller
						name={`missions[${i}].date_fin`}
						rules={{ required: true }}
						control={control}
						render={({ field: { onChange, value } }) => (
							<Flatpickr
								disabled={true}
								onChange={([date]) => {
									onChange(date)
								}}
								className='date-input'
								options={{
									mode: 'single',
									locale: French,
									minDate: moment().startOf('day').toDate(),
									dateFormat: 'd/m/Y',
								}}
								value={value}
								style={{
									backgroundColor: '#d3d3d3',
									opacity: 0.6,
									cursor: 'not-allowed',
								}}
							/>
						)}
					/>

					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].date_fin && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("end_date_err2")}
							</div>
						)}
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<span
						style={{
							marginBottom: '1rem',
							color: 'black',
							fontSize: 14,
						}}
					>
						{t("km_number")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</span>

					<div
						style={{
							position: 'relative',
							width: '100%',
						}}
					>
						<Select
							disabled={display}
							{...register(`missions[${i}].kilometrage`, {
								required: true,
							})}
							defaultValue=''
							onChange={(e) => {
								setValue(
									`missions[${i}].kilometrage`,
									e.target.value
								)
								setDistanceVector(
									new Map(
										distanceVector.set(
											`${i}`,
											e.target.value * 1000
										)
									)
								)
							}}
						>
							<option value='' disabled selected>
								{t("select")}
							</option>
							<option value='200'>200 </option>
							<option value='300'>300 </option>
							<option value='400'>400 </option>
						</Select>
						<span
							style={{
								position: 'absolute',
								right: '3rem',
								top: '1rem',
							}}
						>
							KM
						</span>
					</div>

					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].kilometrage && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("km_number_err")}
							</div>
						)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
					}}
				>
					<span
						style={{
							marginBottom: '1rem',
							color: 'black',
							fontSize: 14,
						}}
					>
						{t("loading_time")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</span>
					<Controller
						name={`missions[${i}].taux_chargement`}
						rules={{ required: true }}
						control={control}
						defaultValue='10'
						render={({ field: { onChange, value } }) => (
							<select
								value={value || '10'}
								onChange={(e) => onChange(e.target.value)}
								style={{
									padding: '1rem',
									borderRadius: '0.5rem',
									color: '#858ea8',
									border: 'none',
									fontFamily: 'Montserrat',
									flex: '1',
									outline: 'none',
								}}
							>
								<option value='10'>10 min</option>
								<option value='15'>15 min</option>
								<option value='20'>20 min</option>
								<option value='25'>25 min</option>
								<option value='30'>30 min</option>
							</select>
						)}
					/>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].taux_chargement && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("loading_rate_err")}
							</div>
						)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
						width: '100%',
					}}
				>
					<span
						style={{
							marginBottom: '1rem',
							color: 'black',
							fontSize: 14,
						}}
					>
						{t("useful_note")}
					</span>
					<StyledTextArea
						disabled={display}
						rows={4}
						placeholder=''
						{...register(`missions[${i}].notes`)}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
						width: '100%',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
						}}
					>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							{t("attach_documents")} (PDF)
						</span>

						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							({t("optional")})
						</span>
					</div>

					<UploadFileCommande
						initialFiles={watch(`missions[${i}].files`)}
						name={`file_${i}`}
						onChange={(files) => {
							if (keepFilesAsObjects) {
								setValue(
									`missions[${i}].files`,
									files.map((file) => file)
								)
							} else {
								setValue(
									`missions[${i}].files`,
									files.map((file) => file.id)
								)
							}
						}}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '2.5rem',
						width: '100%',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
						}}
					>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							{t("waybill")} (PDF, XLSX ou CSV)
						</span>
						<span
							style={{
								marginBottom: '1rem',
								color: 'black',
								fontSize: 14,
							}}
						>
							({t("optional")})
						</span>

					</div>

					<UploadRouteLetterFile
						initialFiles={watch(`missions[${i}].originalFile`)}
						initialLettreRoute={watch(
							`missions[${i}].lettres_route`
						)}
						name={`lettres_route${i}`}
						depotAddress={
							watch(`missions[${i}].adresse_debut`)?.label
						}
						taux_chargement={Number(
							watch(`missions[${i}].taux_chargement`) || 0
						)}
						total_kilometrage={Number(
							watch(`missions[${i}].kilometrage`) || 0
						)}
						total_horaire={calculateTotalDuration(
							watch(`missions[${i}].date_debut`),
							watch(`missions[${i}].heure_debut`),
							watch(`missions[${i}].date_fin`),
							watch(`missions[${i}].heure_fin`)
						)}
						onChange={({ id, file }) => {
							setValue(
								`missions[${i}].lettres_route`,
								id || undefined
							)
							setValue(
								`missions[${i}].originalFile`,
								file || undefined
							)
						}}
						simulation={watch(`missions[${i}].simulation`)}
						onSimulationComplete={(simulationData) => {
							setValue(
								`missions[${i}].simulation`,
								simulationData
							)
						}}
					/>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<p
						style={{
							color: 'black',
							//fontWeight: 'bold',
						}}
					>
						{t("manutention")}
						<span style={{ color: 'red' }}>*</span>
					</p>

					<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`manutention_chauffeur-oui-${i}`}
								type='radio'
								value={true}
								{...register(
									`missions[${i}].manutention_chauffeur`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`manutention_chauffeur-oui-${i}`}>
								{t("yes")}
							</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`manutention_chauffeur-non-${i}`}
								type='radio'
								value={false}
								{...register(
									`missions[${i}].manutention_chauffeur`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`manutention_chauffeur-non-${i}`}>
								{t("no")}
							</label>
						</div>
					</div>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].manutention_chauffeur && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("manutention_err")}
							</div>
						)}
				</div>
				{isActiverRippeur && (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
							}}
						>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
								}}
							>
								{t("nombre_rippeur")}
							</span>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
								}}
							>
								({t("optional")})
							</span>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: '1rem',
							}}
						>
							<div>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='13.605'
									height='27.839'
									viewBox='0 0 13.605 27.839'
									style={{
										marginRight: '.5rem',
									}}
								>
									<g id='user' transform='translate(0.5 0.5)'>
										<path
											id='Path_11624'
											d='M31.488,8.816A3.412,3.412,0,1,1,34.9,5.4,3.412,3.412,0,0,1,31.488,8.816Zm0-6.054a2.645,2.645,0,1,0,2.645,2.645A2.645,2.645,0,0,0,31.488,2.762Z'
											transform='translate(-25.195 -1.992)'
											fill='#51c7f2'
											stroke='#51c7f2'
											strokeWidth='1'
										/>
										<path
											id='Path_11625'
											d='M30.917,33.11h-.752a.383.383,0,1,1,0-.767h.752A1.484,1.484,0,0,0,32.4,30.861V24.829a1.7,1.7,0,0,0-1.7-1.7H23.03a1.7,1.7,0,0,0-1.7,1.7v6.034a1.484,1.484,0,0,0,1.484,1.481h.725a.383.383,0,1,1,0,.767h-.725a2.252,2.252,0,0,1-2.249-2.249V24.829A2.472,2.472,0,0,1,23.03,22.36H30.7a2.472,2.472,0,0,1,2.469,2.469v6.034A2.252,2.252,0,0,1,30.917,33.11Z'
											transform='translate(-20.562 -14.552)'
											fill='#51c7f2'
											stroke='#51c7f2'
											strokeWidth='1'
										/>
										<path
											id='Path_11626'
											d='M38.027,48.646A2.029,2.029,0,0,1,36,46.619V40.231a.383.383,0,0,1,.767,0v6.388a1.26,1.26,0,0,0,2.52,0V34.509a.383.383,0,0,1,.767,0v12.11A2.029,2.029,0,0,1,38.027,48.646Z'
											transform='translate(-30.081 -21.807)'
											fill='#51c7f2'
											stroke='#51c7f2'
											strokeWidth='1'
										/>
										<path
											id='Path_11627'
											d='M29.453,48.646a2.029,2.029,0,0,1-2.027-2.027V34.509a.383.383,0,0,1,.767,0v12.11a1.26,1.26,0,0,0,2.52,0V40.231a.383.383,0,0,1,.767,0v6.388A2.029,2.029,0,0,1,29.453,48.646Z'
											transform='translate(-24.794 -21.807)'
											fill='#51c7f2'
											stroke='#51c7f2'
											strokeWidth='1'
										/>
									</g>
								</svg>
							</div>

							<CustomInput
								width={'100%'}
								type='number'
								disabled={display}
								defaultValue={0}
								min={0}
								max={2}
								{...register(`missions[${i}].nombre_rippeur`, {
									valueAsNumber: true,
									min: {
										value: 0,
										message:
											'Le nombre de rippeurs doit être positif',
									},
									max: {
										value: 2,
										message:
											'Le nombre de rippeurs ne peut pas dépasser 2',
									},
								})}
								onBlur={(e) => {
									const val = parseInt(e.target.value, 10)
									if (isNaN(val)) {
										setValue(
											`missions[${i}].nombre_rippeur`,
											0
										)
									} else if (val > 2) {
										setValue(
											`missions[${i}].nombre_rippeur`,
											2
										)
									}
								}}
								onInput={(e) => {
									const val = parseInt(e.target.value, 10)
									if (val > 2) {
										e.target.value = 2
									}
								}}
								onKeyDown={(e) => {
									if (['e', 'E', '+', '-'].includes(e.key)) {
										e.preventDefault() // empêche saisie de caractères invalides
									}
								}}
							/>
						</div>

						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
							}}
						>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
								}}
							>
								{t("number_of_hours")}
							</span>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: '1rem',
							}}
						>
							<CustomInput
								width={'100%'}
								type='text'
								disabled={true}
								{...register(`missions[${i}].heure_rippeur`)}
								style={{
									backgroundColor: '#d3d3d3',
								}}
							/>
						</div>
					</div>
				)}
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<p
						style={{
							color: 'black',
							//fontWeight: 'bold',
						}}
					>
						{t("delivery_location")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</p>
					<div className='radio-btn-group-palettes'>
						<div className='radio'>
							<input
								id={`livraison-1-${i}`}
								type='radio'
								disabled={display}
								value='Entrepot/Magasin/Chantier'
								{...register(`missions[${i}].livraison`, {
									required: true,
								})}
							/>
							<label htmlFor={`livraison-1-${i}`}>
								{t("pickup_point1")}
							</label>
						</div>

						<div className='radio'>
							<input
								id={`livraison-2-${i}`}
								type='radio'
								disabled={display}
								value='Domicile/Batiment/Maison'
								{...register(`missions[${i}].livraison`, {
									required: true,
								})}
							/>
							<label htmlFor={`livraison-2-${i}`}>
								{t("pickup_point2")}
							</label>
						</div>
					</div>

					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].livraison && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("pickup_point_err")}
							</div>
						)}

					<div>
						{livraison.current === 'Domicile/Batiment/Maison' && (
							<div className='etage-section'>
								<div className='etage-wrapper'>
									<div className='etage-label-wrapper'>
										<span className='etage-label'>
											{t("floor")}
										</span>
										<div
											style={{
												position: 'relative',
												display: 'inline-block',
											}}
										>
											<button
												type='button'
												className='info-button'
												onMouseEnter={() =>
													setShowTooltip(true)
												}
												onMouseLeave={() =>
													setShowTooltip(false)
												}
											>
												<Info
													size={16}
													color='#858ea8'
													strokeWidth={2}
												/>
											</button>
											<div
												className={`tooltip ${showTooltip ? 'visible' : ''}`}
											>
												<div className='tooltip-title'>
													{t( "floor_selection")} :
												</div>
												<ul className='tooltip-list'>
													<li>
														- {t("floor_selection_option1")}
													</li>
													<li>
														- {t("floor_selection_option2")}
													</li>
												</ul>
											</div>
										</div>
									</div>

									<Select
										className='select-etage'
										style={{
											backgroundColor: isEtageDisabled
												? '#f3f4f6'
												: 'white',
										}}
										disabled={isEtageDisabled}
										{...register(`missions[${i}].etage`, {
											required: true,
										})}
									>
										<option value='RDC'>
											{t("ground_floor")}
										</option>
										<option value='1-10'>1-10</option>
										<option value='11-20'>11-20</option>
										<option value='21-30'>21-30</option>
									</Select>
								</div>

								{!isEtageDisabled &&
									watch(`missions[${i}].etage`) !== 'RDC' && (
										<div className='input-wrapper'>
											<Controller
												name={`missions[${i}].escalier`}
												control={control}
												rules={{
													validate: (value) => {
														const etage = getValues(
															`missions[${i}].etage`
														)
														const ascenseur =
															getValues(
																`missions[${i}].ascenseur`
															)
														if (
															etage !== 'RDC' &&
															!value &&
															!ascenseur
														) {
															return 'Sélectionnez escalier ou ascenseur'
														}
														return true
													},
												}}
												render={({ field }) => (
													<input
														type='checkbox'
														className={
															isEtageDisabled ||
															watch(
																`missions[${i}].etage`
															) === 'RDC'
																? 'checkbox-disabled'
																: ''
														}
														disabled={
															isEtageDisabled ||
															watch(
																`missions[${i}].etage`
															) === 'RDC'
														}
														checked={
															field.value === true
														}
														onChange={(e) =>
															field.onChange(
																e.target.checked
															)
														}
													/>
												)}
											/>
											<span
												style={{ marginLeft: '0.5rem' }}
											>
												{t("stairs")}
											</span>
										</div>
									)}

								{!isEtageDisabled &&
									watch(`missions[${i}].etage`) !== 'RDC' && (
										<div className='input-wrapper'>
											<Controller
												name={`missions[${i}].ascenseur`}
												control={control}
												rules={{
													validate: (value) => {
														const etage = getValues(
															`missions[${i}].etage`
														)
														const escalier =
															getValues(
																`missions[${i}].escalier`
															)
														if (
															etage !== 'RDC' &&
															!value &&
															!escalier
														) {
															return 'Sélectionnez escalier ou ascenseur'
														}
														return true
													},
												}}
												render={({ field }) => (
													<input
														type='checkbox'
														className={
															isEtageDisabled ||
															watch(
																`missions[${i}].etage`
															) === 'RDC'
																? 'checkbox-disabled'
																: ''
														}
														disabled={
															isEtageDisabled ||
															watch(
																`missions[${i}].etage`
															) === 'RDC'
														}
														checked={
															field.value === true
														}
														onChange={(e) =>
															field.onChange(
																e.target.checked
															)
														}
													/>
												)}
											/>
											<span
												style={{ marginLeft: '0.5rem' }}
											>
												{t("elevator")}
											</span>
										</div>
									)}
							</div>
						)}
					</div>

					{errors?.missions?.[i]?.etage && (
						<div style={{ color: 'red', marginTop: '0.5rem' }}>
							{t("floor_err")}
						</div>
					)}
					{(errors?.missions?.[i]?.escalier ||
						errors?.missions?.[i]?.ascenceur) && (
						<div style={{ color: 'red', marginTop: '0.5rem' }}>
							{t("floor_selection_err")}
						</div>
					)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						marginBottom: '1.5rem',
						width: '100%',
					}}
				>
					<span
						style={{
							marginBottom: '1rem',
							color: 'black',
							fontSize: 14,
						}}
					>
						{t("total_weight")} (kg) <span style={{ color: 'red' }}>*</span>
					</span>
					<CustomInput
						width={'100%'}
						type='number'
						disabled={display}
						min={0}
						{...register(`missions[${i}].poids_total`, {
							required: true,
							min: {
								value: 0,
								message: t("total_weight_err1"),
							},
						})}
					/>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].poids_total && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{errors.missions[i].poids_total.message ||
									t("total_weight_err2")}
							</div>
						)}
				</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<p
						style={{
							color: 'black',
							//fontWeight: 'bold',
						}}
					>
						{t("load_type")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</p>
					<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`nature-chargement-1-${i}`}
								type='radio'
								disabled={display}
								value='vrac'
								{...register(
									`missions[${i}].nature_chargement`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`nature-chargement-1-${i}`}>
								{t("bulk")}
							</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`nature-chargement-2-${i}`}
								type='radio'
								disabled={display}
								value='palette'
								{...register(
									`missions[${i}].nature_chargement`,
									{
										required: true,
									}
								)}
							/>

							<label htmlFor={`nature-chargement-2-${i}`}>
								{t("pallet")}
							</label>
						</div>
					</div>

					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].nature_chargement && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("load_type_err")}
							</div>
						)}
					<div>
						{nature_chargement.current === 'palette' && (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									marginBottom: '1rem',
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										marginBottom: '1.5rem',
										width: '100%',
									}}
								>
									<>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("number_of_pallets")}{' '}
											<span style={{ color: 'red' }}>
												*
											</span>
										</span>
										<CustomInput
											width={'100%'}
											type='number'
											disabled={display}
											min={1}
											{...register(
												`missions[${i}].nombre_palettes`,
												{ required: true }
											)}
										/>
										{errors &&
											errors.missions &&
											errors.missions[i] &&
											errors.missions[i]
												.nombre_palettes && (
												<div
													style={{
														color: 'red',
														marginTop: '0.5rem',
													}}
												>
													{t("number_of_pallets_err")}
												</div>
											)}
									</>
								</div>

								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										//marginBottom: '2.5rem',
										width: '100%',
									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
										}}
									>
										{t("pallet_nature")}{' '}
										<span style={{ color: 'red' }}>*</span>
									</span>
									<StyledTextArea
										disabled={display}
										type='text'
										rows={4}
										placeholder=''
										{...register(
											`missions[${i}].nature_palettes`,
											{ required: true }
										)}
									/>
									{errors &&
										errors.missions &&
										errors.missions[i] &&
										errors.missions[i].nature_palettes && (
											<div
												style={{
													color: 'red',
													marginTop: '0.5rem',
												}}
											>
												{t("pallet_nature_err")}
											</div>
										)}
								</div>
							</div>
						)}
						{nature_chargement.current === 'vrac' && (
							<>
								<div
									style={{
										position: 'relative',
										width: '100%',
									}}
								>
									<CustomInput
										width={'100%'}
										type='number'
										disabled={display}
										required={true}
										min={1}
										{...register(
											`missions[${i}].nombre_dimension`
										)}
									/>
									<span
										style={{
											position: 'absolute',
											right: '3rem',
											top: '1rem',
										}}
									>
										M³
									</span>
								</div>
								{errors &&
									errors.missions &&
									errors.missions[i] &&
									errors.missions[i].nombre_dimension && (
										<div
											style={{
												color: 'red',
												marginTop: '0.5rem',
											}}
										>
											{t("dimension_err")}
										</div>
									)}
							</>
						)}
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '100%',
						marginBottom: '2.5rem',
					}}
				>
					<p
						style={{
							color: 'black',
							//fontWeight: 'bold',
						}}
					>
						{t("transport_type")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</p>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							//marginBottom: '1rem',
						}}
					>
						<div
							style={{
								display: 'flex',
								flexDirection: isMobile? 'column' : 'row',
								marginBottom: '1rem',
								gap : isMobile ? '1rem' : 0
							}}
						>
							<div
								style={{
									width: '15rem',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'flex-start',
								}}
							>
								<input
									type='radio'
									disabled={display}
									style={{
										marginRight: '1rem',
									}}
									{...register(
										`missions[${i}].type_transport`,
										{
											required: true,
										}
									)}
									value={'Véhicule léger'}
								/>

								<span
									style={{
										marginRight: '0.5rem',
									}}
								>
									{t("vehicle_type2")}
								</span>
								<img
									src={VehiculeLeger}
									style={{
										width: 40,
									}}
									alt=''
								/>
							</div>

							<div
								style={{
									width: '15rem',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'flex-start',
								}}
							>
								<input
									style={{
										marginRight: '1rem',
									}}
									disabled={display}
									type='radio'
									{...register(
										`missions[${i}].type_transport`,
										{
											required: true,
										}
									)}
									value={'Poids lourds'}
								/>

								<span
									style={{
										marginRight: '0.5rem',
									}}
								>
									{t("vehicle_type1")}
								</span>

								<img
									src={PoidsLours}
									style={{
										width: 40,
									}}
									alt=''
								/>
							</div>
						</div>
					</div>
					{type_transport.current && (
						<>
							<Seperator />

							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									//marginBottom: '1rem',
								}}
							>
								{type_transport.current !== 'Poids lourds' && (
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											width: '100%',
										}}
									>
										<div style={{ width: '100%' }}>
											<div
												style={{
													display: 'flex',
													flexDirection: isMobile? 'column' : 'row',
													marginBottom: '1rem',
													width: '100%',
													gap : isMobile ? '1rem'  :0
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile? '100%':'48%',
														marginRight: isMobile? 0 :'2%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={Break}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? '100%' :'50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isBreakDisabled
															}
															{...register(
																`missions[${i}].type_transport_details`,
																{
																	required: true,
																}
															)}
															value='Break'
														/>

														<span
															style={{
																marginRight:'0.5rem',
															}}
														>
															{t("break")}
														</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontWeight:
																	'bold',
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
															}}
														>
															1097 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width:isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															6m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															3750mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															1956mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															1320mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															1097kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															2 pal europe{' '}
														</span>
													</div>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile? '100%' : '48%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={Fourgon12}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isF12Disabled
															}
															{...register(
																`missions[${i}].type_transport_details`,
																{
																	required: true,
																}
															)}
															value='Fourgon 12m³'
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("fourgon")} 12m³
														</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															1244 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width:isMobile?'100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															12m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															3030mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2070mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															1320mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															1244kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															5 pal europe
														</span>
													</div>
												</div>
											</div>
										</div>
										<div style={{ width: '100%' }}>
											<div
												style={{
													display: 'flex',
													flexDirection: isMobile? 'column' : 'row',
													marginBottom: '1rem',
													width: '100%',
													gap : isMobile ? '1rem'  :0
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile? '100%':'48%',
														marginRight: isMobile? 0 :'2%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={Fourgon14}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isF14Disabled
															}
															{...register(
																`missions[${i}].type_transport_details`,
																{
																	required: true,
																}
															)}
															value='Fourgon 14m³'
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("fourgon")} 14m³
														</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																fontWeight:
																	'bold',
																marginRight:
																	'0.5rem',
															}}
														>
															1353 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															14m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															3680mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2070mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															1820mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															1353kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															6 pal europe
														</span>
													</div>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile? '100%' : '48%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={vehiculeCamion}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'110px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>
													<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isC20Disabled
															}
															{...register(
																`missions[${i}].type_transport_details`,
																{
																	required: true,
																}
															)}
															value='Camion 20m³'
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("camion")} 20m³
														</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															1200 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '13px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															20m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															4320mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2070mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															2100mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															1200kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															7 pal europe
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>

							{type_transport.current !== 'Poids lourds' && (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										//marginBottom: '2.5rem',
									}}
								>
									<Seperator />
									<span
										style={{
											marginBottom: '1rem',
											color: 'black',
											fontSize: 14,
										}}
									>
										{t("light_vehicle_options")}{' '}
										<span style={{ color: 'red' }}>*</span>
									</span>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '1rem',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: isMobile? 'column' : 'row',
												marginBottom: '1rem',
												gap : isMobile ? '1rem' : 0 
											}}
										>
											<div
												style={{
													width: '15rem',
													display: 'flex',
													alignItems: 'center',
													justifyContent:
														'flex-start',
												}}
											>
												<input
													type='checkbox'
													style={{
														marginRight: '1rem',
													}}
													disabled={display}
													{...register(
														`missions[${i}].options_vehicule_leger`,
														{
															required: true,
														}
													)}
													value={'Frigorifique'}
													onChange={(e) => {
														const isChecked =
															e.target.checked
														const updatedOptions =
															isChecked
																? [
																		...optionsVehiculeLegerValue,
																		'Frigorifique',
																	]
																: optionsVehiculeLegerValue.filter(
																		(
																			option
																		) =>
																			option !==
																			'Frigorifique'
																	)
														const bacheeIndex =
															updatedOptions.indexOf(
																'Bachée'
															)
														if (
															bacheeIndex !== -1
														) {
															updatedOptions.splice(
																bacheeIndex,
																1
															)
														}
														setValue(
															`missions[${i}].options_vehicule_leger`,
															updatedOptions,
															
														)
														handleOptionChange(e)
													}}
												/>

												<span
													style={{
														marginRight: '0.5rem',
													}}
												>
													{t("refrigerated")}
												</span>
											</div>
											{type_transport_details ===
												'Camion 20m³' && (
												<div
													style={{
														width: '15rem',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														disabled={display}
														{...register(
															`missions[${i}].options_vehicule_leger`,
															{
																required: true,
															}
														)}
														value={'Bachée'}
														onChange={(e) => {
															const isChecked =
																e.target.checked
															const updatedOptions =
																isChecked
																	? [
																			...optionsVehiculeLegerValue,
																			'Bachée',
																		]
																	: optionsVehiculeLegerValue.filter(
																			(
																				option
																			) =>
																				option !==
																				'Bachée'
																		)
															const frigorifiqueIndex =
																updatedOptions.indexOf(
																	'Frigorifique'
																)

															if (
																frigorifiqueIndex !==
																-1
															) {
																updatedOptions.splice(
																	frigorifiqueIndex,
																	1
																)
															}
															setValue(
																`missions[${i}].options_vehicule_leger`,
																updatedOptions
															)
															handleOptionChange(
																e
															)
														}}
													/>

													<span
														style={{
															marginRight:
																'0.5rem',
														}}
													>
														{t("tarped")}
													</span>
												</div>
											)}
											<div
												style={{
													width: '15rem',
													display: 'flex',
													alignItems: 'center',
													justifyContent:
														'flex-start',
												}}
											>
												<input
													type='checkbox'
													style={{
														marginRight: '1rem',
													}}
													disabled={display}
													{...register(
														`missions[${i}].options_vehicule_leger`,
														{
															required: true,
														}
													)}
													value={'Tall'}
												/>

												<span
													style={{
														marginRight: '0.5rem',
													}}
												>
													Tall
												</span>
											</div>

											<div
												style={{
													width: '15rem',
													display: 'flex',
													alignItems: 'center',
													justifyContent:
														'flex-start',
												}}
											>
												<input
													type='checkbox'
													style={{
														marginRight: '1rem',
													}}
													disabled={display}
													{...register(
														`missions[${i}].options_vehicule_leger`,
														{
															required: true,
														}
													)}
													value={'Hayon'}
												/>

												<span
													style={{
														marginRight: '0.5rem',
													}}
												>
													{t("liftgate")}
												</span>
											</div>
										</div>

										{type_transport.current == null && (
											<Seperator />
										)}
									</div>
								</div>
							)}

							{type_transport.current !== 'Véhicule léger' && (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: '100%',
									}}
								>
									<div style={{ width: '100%' }}>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												marginBottom: '1rem',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: isMobile? 'column' : 'row',
													marginBottom: '1rem',
													width: '100%',
													gap : isMobile ? '1rem'  :0
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile? '100%': '48%',
														marginRight: isMobile ? 0 : '2%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={tonnes7}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? '100%': '50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isV75TDisabled
															}
															{...register(
																`missions[${i}].vehicule_poids_lourds`,
																{
																	required: true,
																}
															)}
															value='7,5 Tonnes'
														/>

														<span>7,5 Tonnes</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															2470 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width:isMobile? '100%' :'70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															30m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															6575mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2045mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															2400mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															2470kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															16 pal europe
														</span>
													</div>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile ? '100%' : '48%',
														marginTop: -5,
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={tonnes12}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? "100%" : '50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																is12TDisabled
															}
															{...register(
																`missions[${i}].vehicule_poids_lourds`,
																{
																	required: true,
																}
															)}
															value='12 Tonnes'
														/>

														<span>12 Tonnes</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															5600 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															45m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															7540mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2480mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															2500mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															5600kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															19 pal europe
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div style={{ width: '100%' }}>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: isMobile? 'column' : 'row',
													marginBottom: '1rem',
													width: '100%',
													gap : isMobile ? '1rem'  :0
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width:isMobile? '100%' : '48%',
														marginRight: isMobile? 0 :'2%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={tonnes19}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? '100%' : '50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																is19TDisabled
															}
															{...register(
																`missions[${i}].vehicule_poids_lourds`,
																{
																	required: true,
																}
															)}
															value='19 Tonnes'
														/>

														<span>19 Tonnes</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															9200 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile ? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															58m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :
															9100mm{' '}
														</span>
														<span>
															{t("vehicle_detail3")} :
															2470mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															2490mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															9200kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															22 pal europe
														</span>
													</div>
												</div>
												{watch('type_commande') !==
													'course-a-course' && (
													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															width: isMobile? '100%' : '48%',
														}}
													>
														<div
															style={{
																width: '100%',
																height: 'auto',
																marginBottom:
																	'0.5rem',
															}}
														>
															<img
																src={SemiImg}
																style={{
																	width: '100%',
																	height: 'auto',
																	maxWidth:
																		'140px',
																	maxHeight:
																		'80px',
																	objectFit:
																		'cover',
																}}
																alt=''
															/>
														</div>
														<div
															style={{
																width: isMobile ? '100%' : '50%',
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
																marginTop: -20,
															}}
														>
															<input
																type='radio'
																style={{
																	marginRight:
																		'1rem',
																}}
																disabled={semi}
																{...register(
																	`missions[${i}].vehicule_poids_lourds`,
																	{
																		required: true,
																	}
																)}
																value='Semi'
															/>

															<span>{t("semi")}</span>
														</div>
														<div
															style={{
																marginLeft: 36,
															}}
														>
															<span
																style={{
																	fontSize:
																		'14px',
																	marginRight:
																		'0.5rem',
																	fontWeight:
																		'bold',
																}}
															>
																27000 kg
															</span>
														</div>

														<div
															style={{
																display: 'flex',
																flexDirection:
																	'column',
																background:
																	'#f2f3f4',
																padding: 10,
																width: isMobile ? '100%' : '70%',
																borderRadius:
																	'5px',
																marginTop:
																	'10px',
																fontSize:
																	'14px',
																lineHeight:
																	'1.5',
															}}
														>
															<span>
																{t("vehicle_detail1")}
																: 86m³{' '}
															</span>
															<span>
																{t("vehicle_detail2")} :13500mm
															</span>
															<span>
																{t("vehicle_detail3")} :
																2470mm{' '}
															</span>
															<span>
																{t("vehicle_detail4")} :
																2590mm{' '}
															</span>
															<span>
																{t("vehicle_detail5")} :
																27000kg{' '}
															</span>
															<span>
																{t("vehicle_detail6")} : 33 pal
																europe
															</span>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>

									<div style={{ width: '100%' }}>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												marginBottom: '1rem',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection: isMobile? 'column' : 'row',
													marginBottom: '1rem',
													width: '100%',
													gap : isMobile ? '1rem'  :0
												}}
											>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width: isMobile ? '100%' : '48%',
														marginRight:isMobile? 0: '2%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={Semi}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'120px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? '100%' : '50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={
																isTracteurSemiDisabled
															}
															{...register(
																`missions[${i}].vehicule_poids_lourds`,
																{
																	required: true,
																}
															)}
															value='Tracteur+semi'
														/>

														<span>
															{t("tractor_semi")}
														</span>
													</div>
													<div
														style={{
															marginLeft: 36,
														}}
													>
														<span
															style={{
																fontSize:
																	'14px',
																marginRight:
																	'0.5rem',
																fontWeight:
																	'bold',
															}}
														>
															27000 kg
														</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<span>
															{t("vehicle_detail1")} :
															86m³{' '}
														</span>
														<span>
															{t("vehicle_detail2")} :13500mm
														</span>
														<span>
															{t("vehicle_detail3")} :
															2470mm{' '}
														</span>
														<span>
															{t("vehicle_detail4")} :
															2590mm{' '}
														</span>
														<span>
															{t("vehicle_detail5")} :
															27000kg{' '}
														</span>
														<span>
															{t("vehicle_detail6")}:
															33 pal europe
														</span>
													</div>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'column',
														width:isMobile? '100%': '48%',
													}}
												>
													<div
														style={{
															width: '100%',
															height: 'auto',
															marginBottom:
																'0.5rem',
														}}
													>
														<img
															src={tracteurSemi}
															style={{
																width: '100%',
																height: 'auto',
																maxWidth:
																	'100px',
																maxHeight:
																	'80px',
																objectFit:
																	'cover',
															}}
															alt=''
														/>
													</div>

													<div
														style={{
															width: isMobile? '100%' : '50%',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='radio'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={false}
															{...register(
																`missions[${i}].vehicule_poids_lourds`,
																{
																	required: true,
																}
															)}
															value='Tracteur'
														/>

														<span>{t("tractor")}</span>
													</div>

													<div
														style={{
															display: 'flex',
															flexDirection:
																'column',
															background:
																'#f2f3f4',
															padding: 10,
															width: isMobile? '100%' : '70%',
															borderRadius: '5px',
															marginTop: '10px',
															fontSize: '14px',
															lineHeight: '1.5',
														}}
													>
														<div
															style={{
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<span>
																{t("vehicle_detail2")}
																:{' '}
															</span>
															<span>2.45 M</span>
														</div>
														<div
															style={{
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<span>
																{t("vehicle_detail3")}
																:{' '}
															</span>
															<span>1.50 M</span>
														</div>
														<div
															style={{
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<span>
																{t("vehicle_detail4")}
																:{' '}
															</span>
															<span>1.60 M</span>
														</div>
														<div
															style={{
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'flex-start',
															}}
														>
															<span>
																{t("vehicle_detail7")}
																:{' '}
															</span>
															<span>6 m³</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<Seperator />
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("heavy_truck_options")}{' '}
											<span style={{ color: 'red' }}>
												*
											</span>
										</span>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												marginBottom: '1rem',
											}}
										>
											<div
												style={{
													display: 'flex',
													flexDirection:isMobile? 'column': 'row',
													marginBottom: '1rem',
													gap : isMobile ? '1rem' : 0
												}}
											>
												<div
													style={{
														width: '15rem',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														disabled={display}
														{...register(
															`missions[${i}].options_poids_lourds`,
															{
																required: true,
															}
														)}
														value={'Frigorifique'}
														onChange={(e) => {
															const isChecked =
																e.target.checked
															const updatedOptions =
																isChecked
																	? [
																			...optionsPoidsLourdsValue,
																			'Frigorifique',
																		]
																	: optionsPoidsLourdsValue?.filter(
																			(
																				option
																			) =>
																				option !==
																				'Frigorifique'
																		)
															const bacheeIndex =
																updatedOptions.indexOf(
																	'Bachée'
																)
															if (
																bacheeIndex !==
																-1
															) {
																updatedOptions.splice(
																	bacheeIndex,
																	1
																)
															}
															setValue(
																`missions[${i}].options_poids_lourds`,
																updatedOptions
															)
															handleOptionChange(
																e
															)
														}}
													/>

													<span
														style={{
															marginRight:
																'0.5rem',
														}}
													>
														{t("refrigerated")}
													</span>
												</div>
												{type_transport_details_poids_lourds !==
													'Tracteur' && (
													<div
														style={{
															width: '15rem',
															display: 'flex',
															alignItems:
																'center',
															justifyContent:
																'flex-start',
														}}
													>
														<input
															type='checkbox'
															style={{
																marginRight:
																	'1rem',
															}}
															disabled={display}
															{...register(
																`missions[${i}].options_poids_lourds`,
																{
																	required: true,
																}
															)}
															value={'Bachée'}
															onChange={(e) => {
																const isChecked =
																	e.target
																		.checked
																const updatedOptions =
																	isChecked
																		? [
																				...optionsPoidsLourdsValue,
																				'Bachée',
																			]
																		: optionsPoidsLourdsValue.filter(
																				(
																					option
																				) =>
																					option !==
																					'Bachée'
																			)
																const frigorifiqueIndex =
																	updatedOptions.indexOf(
																		'Frigorifique'
																	)

																if (
																	frigorifiqueIndex !==
																	-1
																) {
																	updatedOptions.splice(
																		frigorifiqueIndex,
																		1
																	)
																}
																setValue(
																	`missions[${i}].options_poids_lourds`,
																	updatedOptions
																)
																handleOptionChange(
																	e
																)
															}}
														/>

														<span
															style={{
																marginRight:
																	'0.5rem',
															}}
														>
															{t("tarped")}
														</span>
													</div>
												)}
												<div
													style={{
														width: '15rem',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														disabled={display}
														{...register(
															`missions[${i}].options_poids_lourds`,
															{
																required: true,
															}
														)}
														value={'Tall'}
													/>

													<span
														style={{
															marginRight:
																'0.5rem',
														}}
													>
														Tall
													</span>
												</div>

												<div
													style={{
														width: '15rem',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														disabled={display}
														{...register(
															`missions[${i}].options_poids_lourds`,
															{
																required: true,
															}
														)}
														value={'Hayon'}
													/>

													<span
														style={{
															marginRight:
																'0.5rem',
														}}
													>
														{t("liftgate")}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}
						</>
					)}
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].type_transport && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("transport_type_err")}
							</div>
						)}
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].type_transport_details && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("transport_type_err2")}
							</div>
						)}
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].vehicule_poids_lourds && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("transport_type_err2")}
							</div>
						)}
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						(errors.missions[i].options_vehicule_leger ||
							errors.missions[i].options_poids_lourds) && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("transport_type_err3")}
							</div>
						)}
					{/* {errors && */}
					{/* 	errors.missions && */}
					{/* 	errors.missions[i] && */}
					{/* 	errors.missions[i].options_poids_lourd && ( */}
					{/* 		<div style={{ color: 'red', marginTop: '0.5rem' }}> */}
					{/* 			Veuillez cocher au moins une option pour le type */}
					{/* 			de transport. */}
					{/* 		</div> */}
					{/* 	)} */}
				</div>
				<div>
					<p
						style={{
							color: 'black',
							//fontWeight: 'bold',
						}}
					>
						{t("dangerous_materials")}{' '}
						<span style={{ color: 'red' }}>*</span>
					</p>

					<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`danger-oui-${i}`}
								type='radio'
								disabled={display}
								value={true}
								{...register(`missions[${i}].danger`, {
									required: true,
								})}
							/>

							<label htmlFor={`danger-oui-${i}`}>{t("yes")}</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`danger-non-${i}`}
								type='radio'
								disabled={display}
								value={false}
								{...register(`missions[${i}].danger`, {
									required: true,
								})}
							/>

							<label htmlFor={`danger-non-${i}`}>Non</label>
						</div>
					</div>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].danger && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("dangerous_materials_err")}
							</div>
						)}
				</div>
				<div>
					<p
						style={{
							color: 'red',
							fontWeight: 'bold',
						}}
					>
						{t("goods_insurance")}
					</p>

					<p
						style={{
							color: 'black',
							fontWeight: 'bold',
						}}
					>
						{t("shipment_value")}
					</p>

					<div
						className='radio-btn-group-palettes'
						style={{
							display: 'flex',
							flexDirection: 'row',
							marginBottom: '2rem',
						}}
					>
						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`assurance-oui-${i}`}
								type='radio'
								disabled={display}
								value={true}
								{...register(`missions[${i}].assurance`, {
									required: true,
								})}
							/>

							<label htmlFor={`assurance-oui-${i}`}>{t("yes")}</label>
						</div>

						<div
							className='radio'
							style={{
								marginRight: '1rem',
							}}
						>
							<input
								id={`assurance-non-${i}`}
								type='radio'
								disabled={display}
								value={false}
								{...register(`missions[${i}].assurance`, {
									required: true,
								})}
							/>

							<label htmlFor={`assurance-non-${i}`}>{t("no")}</label>
						</div>
					</div>
					{errors &&
						errors.missions &&
						errors.missions[i] &&
						errors.missions[i].assurance && (
							<div style={{ color: 'red', marginTop: '0.5rem' }}>
								{t("insurance_err1")}
							</div>
						)}
					<div>
						{assurance.current === 'true' && (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										justifyContent: 'center',
										//width: '30%',
										marginRight: '1rem',
									}}
								>
									<span
										style={{
											color: 'black',
											fontWeight: 'bold',
											marginBottom: '1rem',
										}}
									>
										{t("load_value")}
									</span>

									<div
										style={{
											position: 'relative',
											width: '100%',
										}}
									>
										<CustomInput
											width={'100%'}
											type='text'
											disabled={display}
											{...register(
												`missions[${i}].assurance_amount`,
												{
													validate: (value) => {
														const numericValue =
															Number(
																value.replace(
																	/\s+/g,
																	''
																)
															)
														const onlyDigits =
															/^\d+$/
														if (!value) {
															return "Le montant de l'assurance est requis."
														} else if (
															isNaN(
																numericValue
															) ||
															!onlyDigits.test(
																value
															)
														) {
															return 'Veuillez entrer une valeur numérique valide.'
														} else if (
															numericValue <= 0
														) {
															return 'Le montant doit être supérieur à zéro.'
														}
														return true
													},
													required:
														"Le montant de l'assurance est requis.",
												}
											)}
										/>
										<span
											style={{
												position: 'absolute',
												right: '3rem',
												top: '1rem',
												color: 'red',
											}}
										>
											€
										</span>
									</div>
								</div>

								<p
									style={{
										color: 'black',
										fontWeight: 'bold',
									}}
								>
									{t("load_value_option")}
								</p>
								{errors &&
									errors.missions &&
									errors.missions[i] &&
									errors.missions[i].assurance_amount && (
										<div style={{ color: 'red' }}>
											{
												errors.missions[i]
													.assurance_amount.message
											}
										</div>
									)}
							</div>
						)}
					</div>
				</div>
			</div>

			{/* Bouton de sauvegarde de template avec logique stricte */}
			{canSaveAsTemplate() ? (
				<div
					style={{
						marginTop: '3rem',
						marginBottom: '2rem',
						borderTop: '1px solid #e2e8f0',
						paddingTop: '2rem',
					}}
				>
					<button
						type='button'
						onClick={() => setShowSaveTemplateModal(true)}
						disabled={isSavingTemplate}
						style={{
							backgroundColor: '#059669',
							border: 'none',
							padding: '0.75rem 1rem',
							borderRadius: '0.5rem',
							color: 'white',
							fontSize: '0.875rem',
							fontWeight: '500',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							gap: '0.5rem',
							transition: 'all 0.2s',
							width: '100%',
							justifyContent: 'center',
						}}
						onMouseEnter={(e) => {
							e.target.style.backgroundColor = '#047857'
						}}
						onMouseLeave={(e) => {
							e.target.style.backgroundColor = '#059669'
						}}
					>
						<Save size={16} />
						<span>
							{t("save_template")}
						</span>
					</button>
					<p
						style={{
							fontSize: '0.75rem',
							color: '#6b7280',
							marginTop: '0.5rem',
							textAlign: 'center',
						}}
					>
						{t("save_template_2")}
					</p>
				</div>
			) : (
				// Affichage des champs manquants si la configuration n'est pas complète
				!selectedTemplate && (
					<div
						style={{
							marginTop: '3rem',
							marginBottom: '2rem',
							borderTop: '1px solid #e2e8f0',
							paddingTop: '2rem',
						}}
					>
						<div
							style={{
								backgroundColor: '#fef3c7',
								border: '1px solid #f59e0b',
								borderRadius: '0.5rem',
								padding: '1rem',
								marginBottom: '1rem',
							}}
						>
							<h4
								style={{
									color: '#92400e',
									fontSize: '0.875rem',
									fontWeight: '600',
									marginBottom: '0.5rem',
									margin: '0 0 0.5rem 0',
								}}
							>
								{t("save_emplate_err1")}
							</h4>
							<p
								style={{
									color: '#92400e',
									fontSize: '0.75rem',
									marginBottom: '0.5rem',
									margin: '0 0 0.5rem 0',
								}}
							>
								{t("save_emplate_err2")} :
							</p>
							<ul
								style={{
									color: '#92400e',
									fontSize: '0.75rem',
									marginLeft: '1rem',
									margin: '0 0 0 1rem',
								}}
							>
								{getMissingFields().map((field, index) => (
									<li key={index}> {field}</li>
								))}
							</ul>
						</div>

						<button
							type='button'
							disabled={true}
							style={{
								backgroundColor: '#9ca3af',
								border: 'none',
								padding: '0.75rem 1rem',
								borderRadius: '0.5rem',
								color: 'white',
								fontSize: '0.875rem',
								fontWeight: '500',
								cursor: 'not-allowed',
								display: 'flex',
								alignItems: 'center',
								gap: '0.5rem',
								width: '100%',
								justifyContent: 'center',
								opacity: 0.6,
							}}
						>
							<Save size={16} />
							<span>
								{t("save_template_err_button")}
							</span>
						</button>
					</div>
				)
			)}

			<TemplateModal
				isOpen={showSaveTemplateModal}
				onClose={() => setShowSaveTemplateModal(false)}
				onSave={handleSaveAsTemplate}
				missionData={getCurrentMissionData()}
				loading={isSavingTemplate}
			/>
		</div>
	)
}

export default MissionsMiseADispo
